import {Image} from 'react-konva';
import React, {useContext } from 'react';
import { ImageLayerInterface } from '../../../types/images-layer';
import { VisualContext } from '../../../context/modules/dimensions/VisualContext';
import { getVehicleName } from '../../../utils/getVehicleName';
import { getLang } from '../../../trans';

const ImageLayer: React.FC<ImageLayerInterface> = ({
  vehicle,
  img,
  x,
  y,
  width,
  height,
  imageRef
}) => {
  const visualCtx = useContext(VisualContext);
  const lang = getLang();

  return (
    <Image
      opacity={visualCtx?.vehicle?.acode == vehicle.acode ? 1 : 0.5}
      image={img}
      role="img"
      alt={getVehicleName(vehicle, lang)}
      x={x}
      y={y}
      width={width}
      height={height}
      ref={imageRef}
    />
  );
};

export default ImageLayer;
